import React, { useEffect, useState, useMemo } from 'react';
import WebAPIUtils from 'utils/AccessorialRequestWebAPIUtils';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import CargomaticInput from '../../../v2/input';
import LaneRateAuditTable from './LaneRateAuditTable';

const PER_PAGE = 10;

const LaneRateAudits = ({ rate, type }) => {
  const [audits, setAudits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [skip, setSkip] = useState(0);
  const [searchEvent, setSearchEvent] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    getAudits(rate, searchEvent);
  }, [page, skip, rate, searchEvent]);

  const onEventChange = (event) => {
    setSearchEvent(event);
  };

  const debouncedChangeHandler = useMemo(
    () => debounce(onEventChange, 300),
    [],
  );

  // Remove on component unmount bruh
  useEffect(() => {
    return () => {
      debouncedChangeHandler.cancel();
    };
  }, []);

  function handlePageClick(selectedPage) {
    setLoading(true);
    setPage(selectedPage);
    setSkip(((selectedPage || page) - 1) * PER_PAGE);
  }

  const getAudits = async (rate, searchEvent) => {
    if (rate && rate.id) {
      let filterString =
        type === 'laneRates'
          ? { lanerateId: rate.id }
          : { laneaccessorialrateId: rate.id };

      if (searchEvent && searchEvent.length > 0) {
        filterString.event = searchEvent;
      }

      filterString = new URLSearchParams(filterString).toString();

      const fetchAPI =
        type === 'laneRates'
          ? WebAPIUtils.getUserLaneRateAudits
          : WebAPIUtils.getLaneAccessorialRateAudits;

      let response = await fetchAPI(
        `per_page=${PER_PAGE}&skip=${skip}&${filterString}`,
      );

      if (response) {
        const { audits, count, page } = response;

        const mappedResponse = audits.map((item) => {
          return {
            ...item,
            user: item.user || 'CSV Upload',
            customer: rate.name,
            originCity: rate.originCity,
            originZip: rate.originZip,
            destinationCity: rate.destinationCity,
            destinationZip: rate.destinationZip,
          };
        });
        setAudits(mappedResponse);
        setPages(Math.ceil(count / PER_PAGE));
        setTotal(count);
        setPage(page);
      }
      setLoading(false);
    }
  };

  return (
    <div data-testid="div-94a43c40">
      <div data-testid="div-5a49ad38">
        <div data-testid="div-17104985" className="mb-2" />
        <CargomaticInput
          dataTestId="CargomaticInput-3990abd6"
          className="w-60"
          // value={searchEvent || ''}
          placeholder={t('SEARCH_BY_EVENT_NAME')}
          label={titleize(t('SEARCH'))}
          info={t('SEARCH_EVENT_AUDITS')}
          onChange={debouncedChangeHandler}
          name="event"
          type="text" />
        <div data-testid="div-3fc02032" className="mb-4" />
        <LaneRateAuditTable
          items={audits}
          page={page}
          pages={pages}
          total={total}
          onChange={() => {}}
          onPageClick={handlePageClick}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default LaneRateAudits;
